export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/move-f2cbfb0ba33d37b328c4c60ab725f315.svg";